import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { ModelPortfolio } from '@ddt-web/domain';
import * as get from 'lodash/get';
import * as head from 'lodash/head';
import * as isEmpty from 'lodash/isEmpty';
import * as keys from 'lodash/keys';

import { PortfolioFamily } from '../../../models/model-portfolio.interface';
import { ModelFamiliesUtil } from '../../../utils/model-families.util';
import { PillsFilterType } from '../pills/pills-filter-type.enum';


@Component({
	selector: 'mp-models-tabs-container',
	templateUrl: './models-tabs-container.component.html',
	styleUrls: ['./models-tabs-container.component.scss']
})
export class ModelsTabsContainerComponent implements OnInit {

	@Input() public allFamilies: PortfolioFamily[] = [];
	@Input() public mode: 'NEW' | 'COMPARE' = 'NEW';
	@Input() public selectedModelPortfolios: ModelPortfolio[] = [];
	@Input() public showCheckboxes: boolean = false;
	@Input() public allowMultiple: boolean = true;
	@Input() public myPortfoliosTemplate?: TemplateRef<any>;
	@Input() public maxLimit: number = 100;
	@Input() public arrowLeft: boolean = false;
	@Input() public hidePills: boolean = false;
	@Input() public useDasPortfolioId: boolean = false;
	@Output() public onModelSelected: EventEmitter<any> = new EventEmitter();

	public modelsPerCategory: { [categoryId: string]: PortfolioFamily[] } = {};
	public customModelGroups: { [familyId: string]: string };

	public PillsFilterType = PillsFilterType;

	constructor(private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public ngOnInit(): void {

		this.modelsPerCategory = ModelFamiliesUtil.getFamiliesPerCategoryWithModelGrouping(this.allFamilies);
		this.customModelGroups = ModelFamiliesUtil.getGroupIdNames(this.allFamilies, true);

		// in case of ST (my portfolios) , the default tracking tab should be My portfolios
		// otherwise check for custom models and default tracking tab should be the Custom Models' First Group
		// in case of no my portfolios and no custom models, the default tracking tab should be BLK
		const defaultTrackingTab = !isEmpty(this.myPortfoliosTemplate) ? TealiumConstants.MODELS_DIALOG.MY_PORTFOLIOS :
			(!isEmpty(this.customModelGroups) ? get(this.customModelGroups, head(keys(this.customModelGroups))) : TealiumConstants.MODELS_DIALOG.BLK_MODELS);

		const defaultTrackingEvent = new TealiumAnalyticsEvent(TealiumConstants.MODELS_DIALOG.MODELS_WIDGET + TealiumConstants.MODELS_DIALOG.TAB + defaultTrackingTab, {});
		this.tealiumAnalyticsService.trackEventTealium(defaultTrackingEvent);
	}

	public trackTabChange(tab: { index: number; title: string }): void {
		if (!isEmpty(tab) && tab?.title) {
			const event = new TealiumAnalyticsEvent(TealiumConstants.MODELS_DIALOG.MODELS_WIDGET + TealiumConstants.MODELS_DIALOG.TAB + tab?.title, {});
			this.tealiumAnalyticsService.trackEventTealium(event);
		}
	}

	public onModelPortfolioSelected(): void {
		this.onModelSelected.emit();
	}

}
